/**
 * The external dependencies.
 */
import * as R from 'ramda';
import moment from 'moment';
/**
 * The internal dependencies.
 */
import {TASKS_SORTINGS} from '../../common/constants';
import {getFullTimestamp} from '../../common/utilities';

export const getEmptyTaskItem = () => ({
    date: getFullTimestamp(),
    id: null,
    order_id: null,
    place: '',
    priority: 99,
    quantity: null,
    status: null,
    step: 0,
    worker: null,
    enabled: null,
});

export const getSortingInitialValue = (sorting) => {
    return (!TASKS_SORTINGS[sorting]) ? null : moment().utcOffset(0).set({
        'hour': 0,
        'minute': 0,
        'second': 0,
        'milliseconds': 0
    });
};

export const getSortingFormattedValue = (sorting, value) => {
    if (!value) return;
    return (sorting === 'week') ? `KW ${value.format('ww \'YY')}` : value;
};

export const getSortingPrevousValue = (sorting, value) => {
    return moment(value.format('YYYY-MM-DD')).subtract(1, 'week');
};

export const getSortingNextValue = (sorting, value) => {
    return moment(value.format('YYYY-MM-DD')).add(1, 'week');
};

export const getResidueTasks = (tasks, orders) => {
    if (R.isEmpty(tasks) || R.isEmpty(orders)) {
        return [];
    }

    const ordersQuantity = R.zipObj(
        R.pluck('id', orders),
        R.pluck('quantity', orders)
    );

    const tasksQuantity = R.compose(
        R.map((group) => R.compose(
            R.sum,
            R.pluck('quantity')
        )(group)),
        R.groupBy((item) => item.order_id)
    )(tasks);

    if (R.isEmpty(ordersQuantity) || R.isEmpty(tasksQuantity)) {
        return [];
    }

    return []//tasks;
    // return Object.entries(ordersQuantity)
    //  .map(([orderId, quantity]) => {
    //      const occupiedQuantity = tasksQuantity[orderId];

    //      if (!occupiedQuantity || R.equals(quantity, occupiedQuantity)) {
    //          return null;
    //      }

    //      const task = getEmptyTaskItem();
    //      const remainingQuantity = quantity - occupiedQuantity;

    //      return {
    //          ...task,
    //          ...{
    //              id: `${orderId}-residue-${remainingQuantity}`,
    //              quantity: remainingQuantity,
    //              order_id: orderId,
    //          }
    //      }
    // });
};

export const updateTask = (id, data, items) => R.map(
    R.when(R.propEq('id', id), (item) => ({...item, ...data}))
)(items);



// WEBPACK FOOTER //
// ./src/store/tasks/utilities.js